import React, { memo } from 'react';
import useIsDesktopLayout from '@hooks/useIsDesktopLayout';
import Desktop from './Desktop';
import Mobile from './Mobile';

const MainHeaderGroceries = props => {
  const isDesktopLayout = useIsDesktopLayout();
  const Header = isDesktopLayout ? Desktop : Mobile;
  return <Header {...props} />;
};

export default memo(MainHeaderGroceries);
